import { Card } from "@/components/ui/card";
import EventsTableView from "./table";
import useDocumentTitle from "@/components/ui/common/document-title";

const Events = () => {
  useDocumentTitle("Events");
  
  return (
    <div className="w-full p-2 sm:p-4 md:p-5">
      <div className="mb-4">
        {/* <h1 className="text-2xl font-bold text-gray-900">Events</h1>
        <p className="text-gray-600">Manage your events and activities</p> */}
      </div>
      <Card className="pt-4">
        <EventsTableView />
      </Card>
    </div>
  );
};

export default Events;
